// extracted by mini-css-extract-plugin
export default {"chartContainer":"UserStats_chartContainer__3kb14"};